import type { ExtensibleObject } from '@abp/ng.core';

export interface UpdateProfileDto extends ExtensibleObject {
  userName?: string;
  email?: string;
  name?: string;
  surname?: string;
  phoneNumber?: string;
  concurrencyStamp?: string;
}
